import { render, staticRenderFns } from "./IconGlobe.vue?vue&type=template&id=a40d0d24&scoped=true"
import script from "./IconGlobe.vue?vue&type=script&lang=js"
export * from "./IconGlobe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40d0d24",
  null
  
)

export default component.exports